import React, { memo, FunctionComponent } from 'react';
import { OrthographicCamera } from 'three';
import { useDataStore } from '../../zustand';
import { IRoot } from '@r3f-component-data-structure';
import AnchorGroups from './AnchorGroups';

interface IParentProps {
	cameraRef: React.RefObject<OrthographicCamera>;
}

const ScreenRelativeContent: FunctionComponent<IParentProps> = ({ cameraRef }) => {
	const componentsById = useDataStore(({ componentsById }) => componentsById);
	const rootId = useDataStore(({ rootId }) => rootId);
	const sceneIds = (componentsById?.[rootId || ''] as IRoot)?.children || [];

	return (
		<>
			{sceneIds.map((id) => (
				<AnchorGroups cameraRef={cameraRef} key={id} sceneId={id} />
			))}
		</>
	);
};

export default memo(ScreenRelativeContent);
